import _default from './Loader';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Loader/index.js
// module id = 656
// module chunks = 0